export default __webpack_public_path__ + "static/media/BackIcon.35945a8c.svg";